<ui-card-table
  [showDrawer]="showDrawer"
  [hasBackdrop]="true"
  (openedDrawerChange)="openedDrawerChange($event)"
>
  <h4 card-title>Viajes</h4>
  <div class="d-flex justify-content-between align-items-center" card-actions>
    <t-llevo-date-filter
      #dateFilter
      (valueChange)="filter()"
      [disabled]="(dataSource.loading$ | async) ?? false"
      class="mx-1"
    ></t-llevo-date-filter>

    <t-llevo-select-filter
      #vehicleTypeFilter
      label="Tipo de vehículo"
      [data]="(VehicleTypesNames$ | async) ?? []"
      (valueChange)="filter()"
      [disabled]="(dataSource.loading$ | async) ?? false"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>

    <t-llevo-select-filter
      #statusFilter
      label="Mostrar por estado"
      [data]="TravelStates"
      (valueChange)="filter()"
      [disabled]="(dataSource.loading$ | async) ?? false"
      class="mx-1"
      cancelSelectionText="Desactivar filtros"
    ></t-llevo-select-filter>
  </div>
  <div card-search-action class="align-items-center">
    <commonui-search #searchFilter (searchText)="filter()"></commonui-search>
  </div>

  <div
    card-drawer-content
    class="row align-items-start justify-content-start w-100 gx-0"
    commonui-loader
    [appLoader]="(dataSource.loading$ | async) ?? false"
  >
    <div class="col-12">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matSortActive="createdAt"
        matSortDisableClear
        matSortDirection="asc"
      >
        <ng-container matColumnDef="createdAt">
          <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
            Fecha de viaje
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.createdAt | date: 'dd/MM/yyyy - HH:mm' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="vehicleType">
          <mat-header-cell *matHeaderCellDef>
            Tipo de vehículo
          </mat-header-cell>
          <mat-cell *matCellDef="let item">
            {{ item.vehicleType ? item.vehicleType.name : '-' }}
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="client">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >Cliente</mat-header-cell
            >
            <mat-cell *matCellDef="let item">
              <div>
                <span>
                  {{item.client.firstname | nameFormater : item.client.lastname}}
                </span>
              </div>
            </mat-cell>
          </ng-container> -->

        <ng-container matColumnDef="driver">
          <mat-header-cell *matHeaderCellDef> Conductor </mat-header-cell>
          <mat-cell *matCellDef="let item">
            <div>
              <span>
                {{
                  item.driver
                    ? (item.driver.user.firstname
                      | nameFormater: item.driver.user.lastname)
                    : '-'
                }}
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <!-- <ng-container matColumnDef="price">
            <mat-header-cell *matHeaderCellDef mat-sort-header
              >Precio</mat-header-cell
            >
            <mat-cell *matCellDef="let item"> EN DESARROLLO </mat-cell>
          </ng-container> -->

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef>Estado</mat-header-cell>
          <mat-cell *matCellDef="let item">
            <edt-tag border_radius="8px" [color]="item.status | travelStatusColor">
              {{ item.status | formatTravelStatus }}
            </edt-tag>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell
            class="action-col-centered justify-content-center"
            *matHeaderCellDef
          >
            <span class="d-none d-md-block">Acciones</span>
          </mat-header-cell>
          <mat-cell
            class="action-col-centered justify-content-center"
            *matCellDef="let item"
          >
            <div class="d-none d-lg-flex">
              <ng-container>
                <button
                  mat-icon-button
                  matTooltip="Detalles"
                  (click)="openDetailsDialog(item)"
                >
                  <mat-icon svgIcon="eye" class="me-1"></mat-icon>
                </button>
              </ng-container>
            </div>

            <!-- MOBILE ACTIONS MENU-->
            <div class="d-block d-lg-none">
              <button
                mat-icon-button
                [matMenuTriggerFor]="menu"
                aria-label="Acciones"
              >
                <mat-icon
                  svgIcon="expand_vert"
                  class="action_element"
                ></mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <ng-container>
                  <button mat-menu-item (click)="openDetailsDialog(item)">
                    <mat-icon svgIcon="eye"></mat-icon>
                    <span>Detalles</span>
                  </button>
                </ng-container>
              </mat-menu>
            </div>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        <div class="w-100 text-center pt-3 text-muted" *matNoDataRow>
          Sin resultados para mostrar
        </div>
      </mat-table>
    </div>
  </div>
  <mat-paginator
    card-drawer-paginator
    [length]="(dataSource.total$ | async) ?? 0"
    [pageSize]="dataSource.PAGE_SIZE"
    [pageSizeOptions]="dataSource.PAGE_SIZE_OPTIONS"
    #paginator
  >
  </mat-paginator>
  <mat-tab-group animationDuration="200" card-drawer>
    <mat-tab label="Detalles" bodyClass="tab-body"> </mat-tab>
  </mat-tab-group>
</ui-card-table>
